module.exports = __webpack_public_path__ + "img/Q3-image.904a5fce.png";